import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=ed5e517a&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=ed5e517a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5e517a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed5e517a')) {
      api.createRecord('ed5e517a', component.options)
    } else {
      api.reload('ed5e517a', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=ed5e517a&scoped=true&", function () {
      api.rerender('ed5e517a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction/attribute.vue"
export default component.exports